<template>
  <div class="flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-xs">
    <div class="flex flex-wrap items-baseline gap-3">
      <span class="text-xs font-bold uppercase tracking-widest text-gray-500">{{ t("title") }}</span>
      <span class="text-xl font-extrabold leading-tight" :class="verdictColor" data-test="verdict">
        {{ t(`verdict.${analysis.verdict}`) }}
      </span>
    </div>

    <ul
      v-if="analysis.synthesis?.length"
      class="space-y-1 rounded-lg bg-gray-100 px-4 py-3 text-sm leading-snug text-gray-900"
      data-test="synthesis"
    >
      <li v-for="(line, index) in analysis.synthesis" :key="index" class="flex gap-2">
        <span class="text-gray-400">▸</span>
        <span>{{ line }}</span>
      </li>
    </ul>

    <div v-if="analysis.motifs?.length">
      <ul class="space-y-2.5">
        <li v-for="(motif, index) in analysis.motifs" :key="index" class="flex items-baseline gap-2.5 text-sm">
          <span class="relative top-px h-2 w-2 shrink-0 rounded-full" :class="dotColor"></span>
          <span class="min-w-0">
            <span class="font-bold">{{ motif.title }}</span>
            <span v-if="showMotifDetails" class="mt-0.5 block text-sm text-gray-600" data-test="motif-detail">
              {{ motif.text }}
            </span>
          </span>
        </li>
      </ul>
      <button
        type="button"
        class="mt-2 text-xs font-semibold text-primary-dark hover:underline"
        data-test="toggle-motif-details"
        @click="showMotifDetails = !showMotifDetails"
      >
        {{ showMotifDetails ? t("less") : t("more") }}
      </button>
    </div>

    <slot />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

const VERDICT_COLORS = {
  approve: "text-green-700",
  complement: "text-yellow-700",
  refuse: "text-red-700",
};

const DOT_COLORS = {
  approve: "bg-green-600",
  complement: "bg-yellow-500",
  refuse: "bg-red-600",
};

export default {
  name: "AiAnalysisVerdictCard",

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    // Avis rendu de l'agent général (verdict présent).
    analysis: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // Replié d'office : le formulaire de décision, à côté, prend la place.
      showMotifDetails: false,
    };
  },

  computed: {
    verdictColor() {
      return VERDICT_COLORS[this.analysis.verdict] || "text-gray-900";
    },
    dotColor() {
      return DOT_COLORS[this.analysis.verdict] || "bg-gray-400";
    },
  },
};
</script>

<i18n src="./AiAnalysisVerdictCard.i18n.json"></i18n>
